import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './HomePageAddition.css';

function HomePageAddition() {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <div>
      <section className="our-cost-hero-home">
        <motion.div
          className="our-cost-hero-content-home"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h1>{t('our_cost.hero_title')}</h1>
          <p>{t('our_cost.hero_subtitle')}</p>
        </motion.div>
      </section>

      <section className="pricing-factors-home">
        <motion.div
          className="pricing-factors-grid" // Added a wrapper for grid layout if needed, or apply directly
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <motion.div className="pricing-factor-home" variants={itemVariants}>
            <div className="pricing-factor-icon-home">📏</div>
            <h2>{t('our_cost.scope_title')}</h2>
            <p>{t('our_cost.scope_text')}</p>
          </motion.div>
          <motion.div className="pricing-factor-home" variants={itemVariants}>
            <div className="pricing-factor-icon-home">⏳</div>
            <h2>{t('our_cost.timeline_title')}</h2>
            <p>{t('our_cost.timeline_text')}</p>
          </motion.div>
          <motion.div className="pricing-factor-home" variants={itemVariants}>
            <div className="pricing-factor-icon-home">🎨</div>
            <h2>{t('our_cost.design_title')}</h2>
            <p>{t('our_cost.design_text')}</p>
          </motion.div>
          <motion.div className="pricing-factor-home" variants={itemVariants}>
            <div className="pricing-factor-icon-home">⚙️</div>
            <h2>{t('our_cost.tech_title')}</h2>
            <p>{t('our_cost.tech_text')}</p>
          </motion.div>
        </motion.div>
      </section>
      <section className="our_cost_button">
        <Link to="/our_cost">
          <motion.button
            className="cost-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {t('cost_project')}
          </motion.button>
        </Link>
      </section>
    </div>
  );
}

export default HomePageAddition;
